import { render, staticRenderFns } from "./EmailNotificationNotice.vue?vue&type=template&id=64b191fc&scoped=true&"
import script from "./EmailNotificationNotice.vue?vue&type=script&lang=js&"
export * from "./EmailNotificationNotice.vue?vue&type=script&lang=js&"
import style0 from "./EmailNotificationNotice.vue?vue&type=style&index=0&id=64b191fc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64b191fc",
  null
  
)

export default component.exports